import { PropsWithChildren } from "react";
import StepMenuContainer from "../core/StepMenuContainer";
import StepMenuTitle from "../core/StepMenuTitle";
import { StepDefinition, StepMenuButtonState } from "../StepMenu";
import StepMenuSteps from "../core/StepMenuSteps";
import { Button, MobileStepper } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { ViewOptionStateEnum } from "../../contextual-app-bar/ViewOptionStateEnum";
import { ActionMenuItem } from "../../action-menu/ActionMenuItem";
import { ContextActionMenu } from "../../contextual-app-bar/ContextActionMenu";

export type MobileStepMenuProps = {
    steps: Array<StepDefinition>;
    activeStep: number;
    title: string;

    cancelButtonState?: StepMenuButtonState;
    prevButtonState?: StepMenuButtonState;
    nextButtonState?: StepMenuButtonState;
    saveAsNewButtonState?: StepMenuButtonState;
    saveChangesButtonState?: StepMenuButtonState;
    //previewButtonState?: StepMenuButtonState;
    onCancel?: () => void;
    onSaveAsNew?: () => void;
    onSaveChanges?: () => void;
    onStepChange?: (fromStep: number, toStep: number) => void;
    onCancelStep?: () => void;
    //onPreview?: () => void;
    onStepClick?: (step: StepDefinition) => void;

    //showOptionsAction?: boolean;
    onToggleOptionsAction?: () => void;


    viewOptionState?: ViewOptionStateEnum;
    setViewOptionState?: (value: ViewOptionStateEnum) => void;


    onExecuteAction?: (action: ActionMenuItem) => void;
    actions?: ActionMenuItem[];    




};

export default function MobileStepMenu({
    title,
    activeStep,
    steps,
    cancelButtonState,
    prevButtonState,
    nextButtonState,
    saveAsNewButtonState,
    saveChangesButtonState,
    //previewButtonState?: StepMenuButtonState;
    onCancel,
    onSaveAsNew,
    onSaveChanges,
    onStepChange,
    onCancelStep,
    //onPreview?: () => void;
    onStepClick,

    //showOptionsAction,
    onToggleOptionsAction,
    viewOptionState,

    onExecuteAction,
    actions,




    children
}: PropsWithChildren<MobileStepMenuProps>) {

    const activeStepIndex = steps.findIndex(step => step.key === activeStep);
    
    function handlePrev() {

        const prevStep = activeStepIndex - 1 < 0
            ? steps[steps.length - 1].key
            : steps[activeStepIndex - 1].key;

        onStepChange && onStepChange(activeStep, prevStep);
    }

    function handleNext() {

        const nextStep = activeStepIndex + 1 > steps.length - 1
            ? steps[0].key
            : steps[activeStepIndex + 1].key;

        onStepChange && onStepChange(activeStep, nextStep);
    }

    function handleCancel() {
        onCancel && onCancel();
    }

    function handleSaveChanges() {
        onSaveChanges && onSaveChanges();
    }

    return (
        <StepMenuContainer>
            <StepMenuTitle 
                title={title} 
                
                showCancel={true} 
                onCancel={handleCancel}
                additionalAction={
                    <ContextActionMenu 
                        actions={actions}
                        viewOptionState={viewOptionState}
                        onExecuteAction={onExecuteAction}
                        hideOptionsAction={onToggleOptionsAction === undefined}
                        onOverrideViewOptionsClick={onToggleOptionsAction}
                        buttonColor="default"
                        hideAddToFavoritesAction={true}
                        />
                }
                />

            <StepMenuSteps>
                {children}
            </StepMenuSteps>


            <MobileStepper
                variant="text"
                steps={steps.length}
                position="static"
                activeStep={activeStepIndex}
                backButton={
                    activeStepIndex === 0 ?
                    // for spacing in the stepper
                    <Button
                        size="small"
                        disabled={true}
                        onClick={handlePrev}
                    >
                    </Button>
                    :
                    <Button
                            size="small"
                            disabled={prevButtonState?.disabled}
                            onClick={handlePrev}
                            startIcon={<ArrowBackIcon />}
                        >
                            {prevButtonState?.label}
                    </Button>
                }

                nextButton={
                    activeStep === steps[steps.length-1].key ?
                    <Button
                        size="small"
                        disabled={saveChangesButtonState?.disabled}
                        onClick={handleSaveChanges}
                        //endIcon={<ArrowForwardIcon />
                        //}
                    >
                        {saveChangesButtonState?.label}
                    </Button> :

                    <Button
                        size="small"
                        disabled={nextButtonState?.disabled}
                        onClick={handleNext}
                        endIcon={<ArrowForwardIcon />}
                        >
                        {nextButtonState?.label}
                    </Button>

                }
            />


        </StepMenuContainer>
    )
}